export default "__VITE_ASSET__Ca5$nrF0__"